import { App as CapApp } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { useEffect } from "react";
import { useAuth } from "../contexts/AuthProvider";
import { useAnalytics } from "../contexts/analytics/hooks";
import { pushNotificationService } from "../services/pushNotification.service";
import { useUpdateNotificationStatus } from "./useUserSettings";

export const usePushSettingsTracker = () => {
	const { isLoggedIn, userInfo } = useAuth();
	const { mutate: updateNotifStatus } = useUpdateNotificationStatus();
	const { track } = useAnalytics();

	useEffect(() => {
		if (!isLoggedIn || !userInfo?.id || !Capacitor.isNativePlatform()) {
			return;
		}

		const checkAndReportStatus = async () => {
			const currentStatus = await pushNotificationService.checkPermissionStatus();
			const lastStatus = localStorage.getItem("last_notification_permission_status");

			if (currentStatus !== lastStatus) {
				track("notification_permission_changed", {
					status: currentStatus,
					previous_status: lastStatus,
				});
				updateNotifStatus(currentStatus);
				localStorage.setItem("last_notification_permission_status", currentStatus);
			}
		};

		// Check on initial load
		checkAndReportStatus();

		// Check on app resume
		const listener = CapApp.addListener("appStateChange", ({ isActive }) => {
			if (isActive) {
				checkAndReportStatus();
			}
		});

		return () => {
			listener.then((l) => l.remove());
		};
	}, [isLoggedIn, userInfo?.id, updateNotifStatus, track]);
};
